var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',_vm._l((_vm.items),function(itemId){return _c('morphology-item-chip',{key:itemId,staticClass:"mr-1",attrs:{"item-id":itemId,"color":_vm.itemsColors[itemId]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }